
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Landing } from "./pages/user-pages/Landing";
import { Mobile } from "./pages/user-pages/Mobile";
import { Explore } from "./pages/user-pages/Explore";
import { ErrorPage } from "./pages/ErrorPage";
import { About } from "./pages/user-pages/About";
import { Skills } from "./pages/user-pages/Skills";
import { Projects } from "./pages/user-pages/Projects";
import { Contact } from "./pages/user-pages/Contact";
import { Background } from "./config/Background/Background";
import { Login } from "./pages/Login";
// import { BreakpointGuide } from "./config/BreakpointGuide";

function App() {

  return (
    <>
      {/* <BreakpointGuide /> */}
      <Background />
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/mobile" element={<Mobile />} />
          <Route path="/checkmail" element={<Login />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
        
      </Router>
    </>
  );
}

export default App;
